import { render, staticRenderFns } from "./cadastrar-serie.vue?vue&type=template&id=1b18654a&scoped=true&"
import script from "./cadastrar-serie.vue?vue&type=script&lang=js&"
export * from "./cadastrar-serie.vue?vue&type=script&lang=js&"
import style0 from "./cadastrar-serie.vue?vue&type=style&index=0&id=1b18654a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b18654a",
  null
  
)

export default component.exports